import { getGridStringOperators } from '@mui/x-data-grid-pro'

import { CompanyColumnType } from '../companiesDataGridColumns'

export const idColumnModel: CompanyColumnType = {
  field: 'id',
  flex: 1,
  filterOperators: getGridStringOperators().filter((operator) => operator.value === 'contains' || operator.value === 'equals')
}
